const CART_NOTIFICATION_AUTO_CLOSE = true; /* Auto close ein/aus */
const CART_NOTIFICATION_AUTO_CLOSE_DELAY = 4000; /* Zeit bis close */
const CART_ICON_BUMP = false; /* Warenkorbbump ein/aus */
const CART_COUNT_BUMP = true; /* Warenkorb-Zahl-Bump ein/aus */

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.boundStopAutoClose = () => {
      clearTimeout(this.autoCloseTimer);
    };

    this.boundStartAutoClose = () => {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = setTimeout(() => {
        this.close();
      }, CART_NOTIFICATION_AUTO_CLOSE_DELAY);
    };

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    if (CART_ICON_BUMP) {
      const cartIcon = document.querySelector('#cart-icon-bubble');
      if (cartIcon) {
        cartIcon.classList.remove('bump');
        void cartIcon.offsetWidth;
        cartIcon.classList.add('bump');
      }
    }

    if (CART_COUNT_BUMP) {
  const cartCount = document.querySelector('#cart-icon-bubble .cart-count-bubble');
  if (cartCount) {
    cartCount.classList.remove('bump-count');
    void cartCount.offsetWidth;
    cartCount.classList.add('bump-count');

    cartCount.addEventListener(
      'animationend',
      () => {
        cartCount.classList.remove('bump-count');
      },
      { once: true }
    );
  }
}

    clearTimeout(this.autoCloseTimer);

    this.notification.removeEventListener('mouseenter', this.boundStopAutoClose);
    this.notification.removeEventListener('mouseleave', this.boundStartAutoClose);

    if (CART_NOTIFICATION_AUTO_CLOSE) {
      this.notification.addEventListener('mouseenter', this.boundStopAutoClose);
      this.notification.addEventListener('mouseleave', this.boundStartAutoClose);
      this.boundStartAutoClose();
    }

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    clearTimeout(this.autoCloseTimer);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);